import { Select } from '../../../../components/ui';
import { useT } from '../../../../i18n';
import { chonWorkflow, nhomWorkflow } from '../../nghiep-vu/thong-bao';
import type { ProjectOpenRpa, WorkflowLoc } from '../../types';

/**
 * Chọn các Workflow được gửi thông báo (`WorkflowPicker` của native); để trống = mọi Workflow trong phạm vi. Lựa chọn
 * nhóm theo Project; Workflow đã lưu mà OpenCore không còn vẫn hiện để bỏ đi.
 */
export function ChonWorkflow({
  id,
  describedBy,
  projects,
  projectId = '',
  value,
  loading,
  disabled,
  onChange,
}: {
  id?: string;
  describedBy?: string;
  projects: readonly ProjectOpenRpa[];
  /** Project đang chọn ở Phạm vi; rỗng = mọi Project. */
  projectId?: string;
  value: readonly WorkflowLoc[];
  loading?: boolean;
  disabled?: boolean;
  onChange: (ds: WorkflowLoc[]) => void;
}) {
  const { t } = useT();
  return (
    <Select<string[]>
      id={id}
      aria-describedby={describedBy}
      className="w-full"
      mode="multiple"
      allowClear
      showSearch
      maxTagCount="responsive"
      optionFilterProp="label"
      loading={loading}
      disabled={disabled}
      placeholder={t('rpaThongBao.form.chonWorkflow')}
      notFoundContent={t('rpaThongBao.form.workflowRong')}
      value={value.map((w) => w.id || w.name)}
      onChange={(ids) => onChange(chonWorkflow(ids, projects, value))}
      options={nhomWorkflow(projects, projectId, value).map((g) => ({
        ...g,
        label: g.label || t('rpaThongBao.form.workflowDaMat'),
      }))}
    />
  );
}
